import dayjs from "dayjs";

import { Option } from "@/@types/generics/Option";
import { defaultMedicalAttendanceDepartmentOption } from "@/components/sintegrada/Selects/MedicalAttendanceDepartmentSelect";
import { defaultGender } from "@/components/GenderSelect";
import { defaultDischargeTypeSelectOption } from "@/components/sintegrada/Selects/DischargeTypeSelect";

const startDate = dayjs().add(-1, "month").startOf("day").format("YYYY-MM-DDTHH:mm");
const endDate = dayjs().endOf("day").format("YYYY-MM-DDTHH:mm");

export const dischargeFilterInitialValues = {
	startDate,
	endDate,
	department: defaultMedicalAttendanceDepartmentOption,
	dischargeType: defaultDischargeTypeSelectOption,
	min_age: "",
	max_age: "",
	gender: defaultGender,
	individual: false,
	transferUnit: {} as Option<number>,
};

export type TypeofDischargeFilterInitialValues = typeof dischargeFilterInitialValues;
